import { call, put, takeLatest } from "redux-saga/effects";
import * as effects from "./organizationEffect";
import * as types from "./organizationType";

function* fetchOrganizationsSaga(action) {
  try {
    const { pageNo, pagesize, pagination_required } = action.payload;
    const response = yield call(
      effects.fetchOrganizationsEffect,
      pageNo,
      pagesize,
      pagination_required
    );
    yield put({ type: types.FETCH_LIST_ORGANIZATIONS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_LIST_ORGANIZATIONS_FAILURE, payload: error.message });
  }
}

function* fetchOrganizationByIdSaga(action) {
  try {
    const response = yield call(effects.fetchOrganizationByIdEffect, action.payload);
    yield put({ type: types.FETCH_ORGANIZATION_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_ORGANIZATION_FAILURE, payload: error.message });
  }
}

function* addOrganizationSaga(action) {
  try {
    const response = yield call(effects.addOrganizationEffect, action.payload);
    yield put({ type: types.ADD_ORGANIZATION_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.ADD_ORGANIZATION_FAILURE, payload: error.message });
  }
}

function* updateOrganizationSaga(action) {
  try {
    const response = yield call(
      effects.updateOrganizationEffect,
      action.payload.id,
      action.payload.userData
    );
    yield put({ type: types.UPDATE_ORGANIZATION_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.UPDATE_ORGANIZATION_FAILURE, payload: error.message });
  }
}

function* deleteOrganizationSaga(action) {
  try {
    const response = yield call(effects.deleteOrganizationEffect, action.payload);
    yield put({ type: types.DELETE_ORGANIZATION_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.DELETE_ORGANIZATION_FAILURE, payload: error.message });
  }
}

export function* OrganizationSagas() {
  yield takeLatest(types.FETCH_LIST_ORGANIZATIONS_REQUEST, fetchOrganizationsSaga);
  yield takeLatest(types.FETCH_ORGANIZATION_REQUEST, fetchOrganizationByIdSaga);
  yield takeLatest(types.ADD_ORGANIZATION_REQUEST, addOrganizationSaga);
  yield takeLatest(types.UPDATE_ORGANIZATION_REQUEST, updateOrganizationSaga);
  yield takeLatest(types.DELETE_ORGANIZATION_REQUEST, deleteOrganizationSaga);
}
